<template>
	<div
		class="cargo-card"
		:style="{}"
	>
		<PagesCargosCardInfo :request="request" />
		<div class="cargo-card__actions">
			<UiButton
				:color="ButtonType.primary"
				:size="ButtonSizeType.medium"
				@click="openCommentModal"
			>
				<UiIcon
					name="message-question"
					folder="cargos"
					width="20px"
					height="20px"
					color="var(--white)"
				/>
				<TypographyKTypographyBody5>
					{{ 'Комментарии' }}
				</TypographyKTypographyBody5>
			</UiButton>
			<UiButton
				:color="ButtonType.primary"
				:size="ButtonSizeType.medium"
				@click="openInfoModal"
			>
				<TypographyKTypographyBody5>
					{{ 'Открыть' }}
				</TypographyKTypographyBody5>
			</UiButton>
		</div>
		<PagesCargosInfoModal
			:currentCargoId="request.id"
			v-model="isInfoModalOpen"
			v-if="isInfoModalOpen"
		/>
		<PagesCargosAddedCommentModal
			:currentCargo="request"
			:isLoading="cargoCommentStore.loading.addCargoComment"
			v-model="isCommentModalOpen"
			v-if="isCommentModalOpen"
			@save="saveAddedModalHandler"
		/>
	</div>
</template>

<script setup lang="ts">
	import { useCargoCommentStore } from '~/store/cargoComment.store';
	import type { IDriverRequestsItem } from '~~/shared/interfaces/driverRequests';
	import type { ICargoCommentAddResponse } from '~~/shared/interfaces/cargoComment';
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';

	const emits = defineEmits(['addedComment']);
	const props = withDefaults(
		defineProps<{
			request: IDriverRequestsItem;
			minHeight?: string;
		}>(),
		{
			minHeight: '190px'
		}
	);

	const cargoCommentStore = useCargoCommentStore();
	const isCommentModalOpen = ref(false);
	const isInfoModalOpen = ref(false);

	const saveAddedModalHandler = async (data: ICargoCommentAddResponse) => {
		emits('addedComment', data, { callbackFunction: () => (isCommentModalOpen.value = false) });
	};

	const openCommentModal = () => {
		isCommentModalOpen.value = !isCommentModalOpen.value;
	};

	const openInfoModal = () => {
		isInfoModalOpen.value = !isInfoModalOpen.value;
	};
</script>

<style scoped lang="scss">
	.cargo-card {
		display: flex;
		flex-direction: column;
		position: relative;
		border-radius: 16px;
		width: 100%;
		background-color: var(--white);
		min-height: v-bind(minHeight);
		padding: 13px 48px 13px 15px;

		&__actions {
			display: flex;
			margin-top: 10px;
			gap: 12px;

			button {
				min-width: 110px;
				width: 100%;
				max-width: 180px;
			}
		}
	}
</style>
